import {
  Dialog,
  DialogBackdrop,
  DialogPanel,
  DialogTitle,
} from "@headlessui/react";
import React, { Fragment, ReactNode } from "react";
import { ButtonSecondaryModal } from "../atoms/ButtonSecondaryModal";
import { ButtonPrimaryModal } from "../atoms/ButtonPrimaryModal";
import { PlusIcon } from "@heroicons/react/20/solid";
import { classNames } from "@/shared/utils/classnames";

type ModalProps = {
  onClickCreate?: () => void;
  Close: () => void;
  open: boolean;
  textButtonCreate?: string;
  textButtonClose?: string;
  children?: React.ReactNode;
  tittleModal: string;
  textButtonTopCreate?: string;
  functionButtonTopCreate?: () => void;
  footer?: ReactNode;
  disabledCreated?: boolean;
  onClose?: () => void;
  loader?: boolean;
  className?: string;
  modalWidth?: string; // ✅ Nueva prop
  modalClassName?: string;
};

export const Modal: React.FC<ModalProps> = ({
  onClickCreate,
  footer,
  Close,
  open,
  textButtonCreate,
  textButtonClose,
  children,
  tittleModal,
  textButtonTopCreate,
  loader,
  onClose,
  functionButtonTopCreate,
  disabledCreated,
  modalWidth, // ✅ Se extrae la nueva prop
  modalClassName,
}) => {
  const widthClass = modalWidth ?? "sm:max-w-xl"; // ✅ Clase por defecto si no se pasa

  return (
    <Fragment>
      <Dialog
        open={open}
        onClose={() => onClose?.()}
        className={classNames("relative z-10", modalClassName)}
      >
        <DialogBackdrop
          transition
          className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 data-[enter]:ease-out data-[leave]:ease-in"
        />
        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
            <DialogPanel
              transition
              className={`relative transform overflow-visible rounded-lg bg-white text-left shadow-xl transition-all 
              data-[closed]:translate-y-4 data-[closed]:opacity-0 data-[enter]:duration-300 data-[leave]:duration-200 
              data-[enter]:ease-out data-[leave]:ease-in sm:my-8 sm:w-full ${widthClass} 
              data-[closed]:sm:translate-y-0 data-[closed]:sm:scale-95`}
            >
              <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 rounded-t-sm">
                <div className="">
                  <div className="mt-3 sm:ml-0 sm:mt-0">
                    <div className="flex justify-between items-center">
                      <DialogTitle
                        as="h3"
                        className="text-base font-semibold leading-6 text-gray-900"
                      >
                        {tittleModal}
                      </DialogTitle>
                      {textButtonTopCreate && (
                        <button
                          onClick={functionButtonTopCreate}
                          type="button"
                          className="block rounded-full border-2 border-dashed border-gray-400 p-1 text-gray-400 shadow-sm hover:text-gray-500 focus-visible:outline-none"
                        >
                          <PlusIcon aria-hidden="true" className="h-5 w-5" />
                        </button>
                      )}
                    </div>
                    <div className="mt-2">{children}</div>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 rounded-b-sm">
                {footer ? (
                  footer
                ) : (
                  <div className="flex gap-2">
                    {textButtonClose && (
                      <ButtonSecondaryModal
                        text={textButtonClose}
                        onClick={Close}
                      />
                    )}
                    {textButtonCreate && (
                      <div>
                        <ButtonPrimaryModal
                          loader={loader}
                          disabled={loader || disabledCreated}
                          text={textButtonCreate}
                          onClick={onClickCreate}
                        />
                      </div>
                    )}
                  </div>
                )}
              </div>
            </DialogPanel>
          </div>
        </div>
      </Dialog>
    </Fragment>
  );
};
